/* unplugin-vue-components disabled */import { render } from "./MobilePageFooter.vue?vue&type=template&id=7a0324c8&scoped=true&ts=true"
import script from "./MobilePageFooter.vue?vue&type=script&lang=ts"
export * from "./MobilePageFooter.vue?vue&type=script&lang=ts"

import "./MobilePageFooter.vue?vue&type=style&index=0&id=7a0324c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a0324c8"]])

export default __exports__